import 'zone.js';
import {bootstrapApplication} from '@angular/platform-browser';
import {Amplify} from 'aws-amplify';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from './app/environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolClientId,

      // OPTIONAL - Hosted UI configuration
      loginWith: {
        oauth: {
          domain: environment.cognito.hostedUiDomain,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: ['http://localhost:4200/callback', `${environment.baseUrl}/callback`],
          redirectSignOut: ['http://localhost:4200', environment.baseUrl],
          responseType: 'code',
        },
      },
    },
  },
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
